import React from "react";
import { Error } from "./InputRowError.styled";

const InputRowError = ({ ...props }) => {
  return <Error {...props} />;
};

export default InputRowError;
